export default "__VITE_ASSET__4f494eec__"